import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'materialize-css/dist/css/materialize.min.css'; // Import Materialize CSS
import 'materialize-css/dist/js/materialize.min.js'; // Import Materialize JS
import 'jquery'; // Import jQuery if needed
import 'react-toastify/dist/ReactToastify.css';
import { RippleProvider } from './Components/RippleEffectProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <RippleProvider>
    <App />
    </RippleProvider>
  </React.StrictMode>
);

reportWebVitals();
